// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const estadosPiezasFullfilledReducer = makeSetReducer(['estados_piezas/fullfilled']);
